/* eslint-disable react/prop-types */
import { formatTimestampToAgo } from "../../utils";
import { FilterValue } from "../../components";
import styles from "../../scss/media.module.scss";
import { Tooltip } from "../../components";
import { MediaModel } from "@/database";
import FilterIconSvg from "../../assets/icons/svg/filter_list.svg?react";

import {
  Display_Value_Key as dvk,
  handleFilterChangeUtil,
} from "@/components/Create/utils";
import FilterButton from "@/utils/ui/FilterButton";

export const RenderCreatedBy: React.FC<{
  media: MediaModel;
  onFilterAdd?: (
    key: string,
    value?: FilterValue,
    displayValue?: FilterValue
  ) => void;
  filters?: Record<string, FilterValue>;
  updateIsFilter: (isFilter: boolean) => void;
  updateIsClearFilter: (isClearFilter: boolean) => void;
  handleSetFilters: (filters: Record<string, FilterValue>) => void;
}> = ({
  media,
  onFilterAdd,
  filters,
  updateIsFilter,
  updateIsClearFilter,
  handleSetFilters,
}) =>
  media?.state !== -2 ? (
    <div className="d-flex flex-column gap-1">
      <div className={`text-primary ${styles["hover-filter"]}`}>
        <span className="">{media.ct && formatTimestampToAgo(media.ct)}, </span>
        <div className="d-flex align-items-center text-primary fw-medium">
          <span className="clamp-lines clamp-1 text-capitalize">
            {media.ctbydata?.name}
          </span>
          {media?.ctby !== null && media?.ctby !== undefined && (
            <FilterButton
              filterKey="ctby"
              filterValue={media?.ctby}
              displayText={media?.ctbydata?.name || "--"}
              filters={filters}
              updateIsFilter={updateIsFilter}
              updateIsClearFilter={updateIsClearFilter}
              handleSetFilters={handleSetFilters}
              dvk={dvk}
              filterDisplayName="Uploaded by"
              useContentEvent
            />
          )}
          {/* <span
            onClick={() => {
              const updatefilters = handleFilterChangeUtil(
                'mtbyuser',
                media?.mtbyuser,
                media?.mtbydata?.name,
                filters,
                updateIsFilter,
                updateIsClearFilter,
                dvk,
              );
              handleSetFilters(updatefilters);
            }}
            // className="position-absolute"
            // style={{ right: '-18px', top: '4px' }}
          >
            <Tooltip content={<p className="p-0 mb-0">Filter by this user</p>}>
              <FilterIconSvg className={`${styles['hover-icon']} iconSvg`} />
            </Tooltip> */}
          {/* </span> */}
        </div>
      </div>

      <div className="d-flex flex-column media_hover-filter__Vf+39 H">
        <small className="text-uppercase">Uploaded:</small>
        <div className="d-flex align-items-center text-primary fw-medium">
          <span className="">{media.ct && formatTimestampToAgo(media.ct)}</span>
          <span
            className="clamp-lines clamp-1 ms-1"
            style={{ maxWidth: "50%" }}
          >
            {media?.ctbydata?.name || "--"}
          </span>
          <span
            onClick={() => {
              const updatefilters = handleFilterChangeUtil(
                "ctby",
                media?.ctby,
                media?.ctbydata?.name,
                filters,
                updateIsFilter,
                updateIsClearFilter,
                dvk
              );
              handleSetFilters(updatefilters);
            }}
            // className="position-absolute"
            // style={{ right: '-18px', top: '4px' }}
          >
            <Tooltip content={<p className="p-0 mb-0">Filter by this user</p>}>
              <FilterIconSvg className={`${styles["hover-icon"]} iconSvg`} />
            </Tooltip>
          </span>
        </div>
      </div>
    </div>
  ) : (
    "--"
  );
// {/* <div className="d-flex flex-column pt-2">
//   <small className="text-uppercase">Modified On</small>
//   <div className="text-primary ">{formatTimestampToAgo(media.mt)}</div>
// </div> */}
